var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{ref:"table",attrs:{"selectable":"","select-values":_vm.selectValues,"columns":_vm.columns,"filters":_vm.filters,"pagination":true,"repository-func":_vm.repositoryFunc,"title":_vm.title,"identifier":"supplierProductCatalogTable"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }